// extracted by mini-css-extract-plugin
export var choices = "Quiz-module--choices--c35d2";
export var container = "Quiz-module--container--68523";
export var correctIndicator = "Quiz-module--correct-indicator--3a905";
export var question = "Quiz-module--question--06fe6";
export var questionHeader = "Quiz-module--question-header--22b4b";
export var questionHint = "Quiz-module--question-hint--74390";
export var questionText = "Quiz-module--question-text--a95c9";
export var radioChoice = "Quiz-module--radio-choice--748d8";
export var radioChoiceChecked = "Quiz-module--radio-choice-checked--79bfe Quiz-module--radio-choice--748d8";
export var radioChoiceCheckedCorrect = "Quiz-module--radio-choice-checked-correct--69d4c Quiz-module--radio-choice--748d8";
export var radioChoiceCheckedWrong = "Quiz-module--radio-choice-checked-wrong--2d6b3 Quiz-module--radio-choice--748d8";
export var resultChip = "Quiz-module--result-chip--49cb4";
export var showAnswers = "Quiz-module--show-answers--825c7";
export var showAnswersLabel = "Quiz-module--showAnswersLabel--679ea";